var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPlayStore = function SvgIconPlayStore(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B5C4",
    fillRule: "nonzero",
    d: "M15.185 7.581L2.255.191A1.449 1.449 0 0 0 1.536 0h-.015A1.46 1.46 0 0 0 1.3.02l-.028.004v.001A1.447 1.447 0 0 0 .084 1.452v14.78a1.451 1.451 0 0 0 1.187 1.427l.025.004.084.012.041.004c.033.003.066.004.099.005h.016c.248 0 .497-.063.72-.19l12.929-7.391c.452-.259.73-.74.73-1.26v-.001c0-.521-.278-1.002-.73-1.26zm-5.113-1.467L8.786 7.8l-3.27-4.29 4.556 2.604zm4.486 2.892l-9.043 5.169 5.662-7.428 3.38 1.932a.189.189 0 0 1 .001.327z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPlayStore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-play-store.c68052a8.svg";
export { ForwardRef as ReactComponent };